// Построение и нормализация queryKey. См. docs/data-layer.md §8.

import { normalizeInput } from '~/shared/utils'

/**
 * `queryKey = [key, normalizedInput]`. Без input (undefined) — ключ из одного элемента,
 * попадающий под инвалидацию/матчинг для ЛЮБОГО варианта запроса с этим `key`.
 */
export function buildQueryKey(key: string, input?: unknown): unknown[] {
  if (input === undefined) return [key]
  return [key, normalizeInput(input)]
}
